import type { OrganizationInfo } from "../../api/clientsManagementTypes";

// Internal umbrella organizations co-manage every client; without this each client is listed twice.
export const removeClientsOfRealOrgsFromInternalOrgs = (organizations: OrganizationInfo[]): OrganizationInfo[] => {
  const clientCodesOfRealOrgs = new Set(
    organizations.filter((org) => !org.isInternalOrg).flatMap((org) => org.managesClients.map((c) => c.clientCode))
  );
  return organizations.map((org) =>
    org.isInternalOrg
      ? { ...org, managesClients: org.managesClients.filter((c) => !clientCodesOfRealOrgs.has(c.clientCode)) }
      : org
  );
};
